import { render } from "./ArchivedContainers.vue?vue&type=template&id=263b7571&scoped=true&ts=true"
import script from "./ArchivedContainers.vue?vue&type=script&lang=ts"
export * from "./ArchivedContainers.vue?vue&type=script&lang=ts"

import "./ArchivedContainers.vue?vue&type=style&index=0&id=263b7571&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-263b7571"]])

export default __exports__